import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import {
    buildGraphQLParams,
    convertInStoreProductsListingToAReadableFormat,
    convertInStoreCategoriesToAReadableFormat,
    convertDataToListingDisplay,
    getGraphQLTotalRecords,
    buildElasticGraphQLParams,
} from '../selectors/converterSelector';
import config from '../store/_config';
import {
    createModal,
    hideModal,
} from '../dom/components/confirm-removal-modal';
import {
    getCategoryDropdown,
    getCategoryFromID,
} from '../selectors/categorySelector';
import { getSelectedItems } from '../selectors/converterSelector';
import pluralize from 'pluralize';
import { createAlert } from '../dom/window';
import { getTranslation } from '../lang/main';

export const toggleLoading = (key, value) => {
    return {
        type: 'TOGGLE_IN_STORE_PRODUCT_LOADING',
        key: key,
        value: value,
    };
};
export const updateInStoreProductListHasInitialized = (value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_LIST_HAS_INITIALIZED',
        value: value,
    };
};
export const replaceInStoreCategories = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'REPLACE_IN_STORE_CATEGORIES',
            value: value,
        });
    };
};
export const replaceInStoreProductListDisplay = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_IN_STORE_PRODUCT_LIST_DISPLAY',
            value: value,
        });

        dispatch(resetInStoreSelectedRows(false));
    };
};
export const updateInStoreProductList = (value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_LIST',
        value: value,
    };
};
export const updateInStoreProductCategoryFilter = (categoryID) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_IN_STORE_PRODUCT_LIST_FILTERS',
            value: {
                CategoryID: categoryID,
            },
        });
    };
};
export const updateInStoreProductFilters = () => {
    return (dispatch, getState) => {
        const state = getState();
        const { selectedCategory } = state.inStoreProduct.filterForm;

        const filterData = {
            CategoryID: selectedCategory,
        };

        if (selectedCategory == 0) {
            delete filterData.CategoryID;
        }

        dispatch({
            type: 'UPDATE_IN_STORE_PRODUCT_LIST_FILTERS',
            value: filterData,
        });

        dispatch(requestInStoreProducts());
    };
};
export const updateInStoreProductFilterForm = (key, value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_FILTER_FORM_DATA',
        key: key,
        value: value,
    };
};
export const updateInStoreProductNewCategoryForm = (key, value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_NEW_CATEGORY_FORM_DATA',
        key: key,
        value: value,
    };
};
export const updateInStoreProductRemoveCategoryForm = (key, value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_REMOVE_CATEGORY_FORM_DATA',
        key: key,
        value: value,
    };
};
export const setActivePage = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_IN_STORE_PRODUCT_LIST_ACTIVE_PAGE',
            value: value,
        });

        dispatch(requestInStoreProducts());
    };
};
export const updateInStoreProductParams = (tableState, tableInstance) => {
    return (dispatch, getState) => {
        const state = getState();
        const { sortBy, sortDirection } = state.inStoreProduct.listParams;
        const { sorted } = tableState;

        if (sorted.length) {
            const newSortBy = sorted[0].id;
            const newSortDirection = sorted[0].desc ? 'DESC' : 'ASC';

            if (sortBy != newSortBy || sortDirection != newSortDirection) {
                dispatch(setSort(newSortBy, newSortDirection));
            }
        } else {
            if (!(sortBy == '' && sortDirection == '')) {
                dispatch(setSort('', ''));
            }
        }
    };
};
export const setTotalRecords = (value) => {
    return {
        type: 'SET_IN_STORE_PRODUCT_LIST_TOTAL_RECORDS',
        value: value,
    };
};
export const setSort = (sortBy, sortDirection) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SET_IN_STORE_PRODUCT_LIST_SORT',
            value: sortBy,
            direction: sortDirection,
        });

        dispatch(requestInStoreProducts());
    };
};
export const setViewBy = (value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_IN_STORE_PRODUCT_LIST_VIEW_TYPE',
            value: value,
        });
    };
};
export const updateInStoreAllCheckboxesValue = () => {
    return (dispatch, getState) => {
        const state = getState();
        const currentSelectedValue = state.inStoreProduct.allCheckboxesSelected;
        const list = Object.entries(state.inStoreProduct.selected);
        let finalSelectedValue = list.length > 0 ? true : false;

        list.map(([id, value]) => {
            if (value === false) {
                finalSelectedValue = value;
            }
        });

        if (finalSelectedValue !== currentSelectedValue) {
            dispatch({
                type: 'UPDATE_IN_STORE_ALL_ROWS_CHECKBOX',
                value: finalSelectedValue,
            });
        }
    };
};
export const updateInStoreAllSelectedRows = (value) => {
    return (dispatch, getState) => {
        const state = getState();
        const list = state.inStoreProduct.list;
        let selected = {};

        Object.keys(list).map((id) => {
            selected[id] = value;
        });

        dispatch({
            type: 'REPLACE_IN_STORE_SELECTED_ROWS',
            value: selected,
        });

        dispatch(updateInStoreAllCheckboxesValue());
    };
};
export const updateInStoreSelectedRow = (key, value) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'UPDATE_IN_STORE_SELECTED_ROW',
            key: key,
            value: value,
        });

        dispatch(updateInStoreAllCheckboxesValue());
    };
};
export const resetInStoreSelectedRows = () => {
    return (dispatch, getState) => {
        dispatch({
            type: 'RESET_IN_STORE_SELECTED_ROWS',
        });

        dispatch(updateInStoreAllCheckboxesValue());
    };
};
export const updateInStoreProductForm = (key, value) => {
    return {
        type: 'UPDATE_IN_STORE_PRODUCT_FORM',
        key: key,
        value: value,
    };
};
export const replaceInStoreProductForm = (value) => {
    return {
        type: 'REPLACE_IN_STORE_PRODUCT_FORM',
        value: value,
    };
};
export const requestInStoreProducts = () => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.inStoreProduct.listing;
        query = query.replace(
            /{params}/,
            buildElasticGraphQLParams(state.inStoreProduct.listParams)
        );

        dispatch(toggleLoading('list', true));

        return axios
            .get(url, {
                withCredentials: true,
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const list = convertInStoreProductsListingToAReadableFormat(
                    response.data.data.readInStoreProducts
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readInStoreProducts,
                    'ID'
                );
                const total = getGraphQLTotalRecords(
                    response.data.data.readInStoreProducts
                );

                // wait for async requests
                Promise.all([
                    dispatch(replaceInStoreProductListDisplay(listingDisplay)),
                    dispatch(updateInStoreProductList(list)),
                    dispatch(setTotalRecords(total)),
                ]).then(() => {
                    dispatch(updateInStoreProductListHasInitialized(true)),
                        dispatch(toggleLoading('list', false));
                });
            })
            .catch((error) => {
                dispatch(updateInStoreProductListHasInitialized(true));
                handleAxiosErrors(error);
            });
    };
};
export const requestInStoreCategories = () => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.inStoreProduct.categories;
        // query = query.replace(/{params}/, buildGraphQLParams(state.inStoreProduct.listParams));

        dispatch(toggleLoading('category', true));

        return axios
            .get(url, {
                withCredentials: true,
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const categories = convertInStoreCategoriesToAReadableFormat(
                    response.data.data.readInStoreProductCategories
                );

                // wait for async requests
                Promise.all([
                    dispatch(replaceInStoreCategories(categories)),
                ]).then(() => {
                    dispatch(toggleLoading('category', false));

                    const categoryDropdown = getCategoryDropdown(categories);
                    if (
                        categoryDropdown.length > 0 &&
                        !state.inStoreProduct.removeCategoryForm
                            .selectedCategory
                    ) {
                        dispatch(
                            updateInStoreProductRemoveCategoryForm(
                                'selectedCategory',
                                categoryDropdown[0].value
                            )
                        );
                    }

                    if (!state.inStoreProduct.filterForm.selectedCategory) {
                        dispatch(
                            updateInStoreProductFilterForm(
                                'selectedCategory',
                                0
                            )
                        );
                    }
                });
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const deleteSelectedInStoreProducts = () => {
    return (dispatch, getState) => {
        const state = getState();

        const selectedIDs = [];
        Object.entries(state.inStoreProduct.selected).forEach(
            ([id, status]) => {
                if (status === true && id != null) {
                    selectedIDs.push(id);
                }
            }
        );

        if (!selectedIDs.length) {
            return;
        }

        dispatch(toggleLoading('list', true));

        return axiosDeleteInStoreProducts(selectedIDs)
            .then((response) => {
                dispatch(requestInStoreProducts());

                // Create alert
                createAlert(
                    {
                        message: getTranslation(
                            'IN_STORE_PRODUCT:REMOVE_PRODUCTS_SUCCESS_MESSAGE'
                        ).replace('{total}', selectedIDs.length),
                    },
                    'success'
                );
            })
            .catch((error) => {
                dispatch(toggleLoading('list', false));
            });
    };
};
export const axiosDeleteInStoreProducts = (ids) => {
    let { url, query } = config.inStoreProduct.delete;
    let data = {
        id: query,
        variables: {
            ID: ids,
        },
    };

    return axios
        .post(url, data, {
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};
export const deleteSelectedInStoreCategory = () => {
    return (dispatch, getState) => {
        const state = getState();

        const selectedCategoryID = state.inStoreProduct.removeCategoryForm.selectedCategory;
        const category = state.inStoreProduct.categoryList[selectedCategoryID] || false;
        const categoryName = category ? category.Title : '';

        let { url, query } = config.inStoreProduct.deleteCategory;
        let data = {
            id: query,
            variables: {
                ID: selectedCategoryID,
            },
        };

        dispatch(toggleLoading('removeCategoryForm', true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                // Flush Form
                dispatch(toggleLoading('removeCategoryForm', false));

                // Re-request category
                dispatch(requestInStoreCategories());

                // Create alert
                createAlert(
                    {
                        message: getTranslation(
                            'IN_STORE_PRODUCT:REMOVE_CATEGORY_SUCCESS_MESSAGE'
                        ).replace('{category_name}', categoryName),
                    },
                    'success'
                );
            })
            .catch((error) => {
                dispatch(toggleLoading('newCategoryForm', false));
                handleAxiosErrors(error);
            });
    };
};
export const createNewInStoreCategory = () => {
    return (dispatch, getState) => {
        const state = getState();

        const newCategoryName =
            state.inStoreProduct.newCategoryForm.categoryName;
        let { url, query } = config.inStoreProduct.createCategory;
        let data = {
            id: query,
            variables: {
                Input: {
                    Title: newCategoryName,
                },
            },
        };

        dispatch(toggleLoading('newCategoryForm', true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                const CategoryID =
                    response.data.data.createInStoreProductCategory.ID;
                // Flush Form
                dispatch(
                    updateInStoreProductNewCategoryForm('categoryName', '')
                );
                dispatch(
                    updateInStoreProductNewCategoryForm(
                        'categoryID',
                        CategoryID
                    )
                );
                dispatch(toggleLoading('newCategoryForm', false));

                // Re-request category
                dispatch(requestInStoreCategories());

                // Create alert
                createAlert(
                    {
                        message: getTranslation(
                            'IN_STORE_PRODUCT:NEW_CATEGORY_SUCCESS_MESSAGE'
                        ).replace('{category_name}', newCategoryName),
                    },
                    'success'
                );

                $('#create-category').removeClass('active');
                $('#select-category').addClass('active');
            })
            .catch((error) => {
                dispatch(toggleLoading('newCategoryForm', false));
                handleAxiosErrors(error);
            });
    };
};
export const submitInStoreProductForm = (formData, callback) => {
    return (dispatch, getState) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        const { ID } = formData;

        let url, query;

        if (ID > 0) {
            url = config.inStoreProduct.update.url;
            query = config.inStoreProduct.update.query;
        } else {
            delete formData.ID;
            url = config.inStoreProduct.create.url;
            query = config.inStoreProduct.create.query;
        }

        let data = {
            id: query,
            variables: {
                Input: formData,
            },
        };

        dispatch(toggleLoading('detailFormSubmit', true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                // Flush Form
                dispatch(
                    updateInStoreProductNewCategoryForm('categoryName', '')
                );
                dispatch(toggleLoading('detailFormSubmit', false));

                // Callbacks
                if (successCallback) successCallback();
                if (alwaysCallback) alwaysCallback();
            })
            .catch((error) => {
                dispatch(toggleLoading('detailFormSubmit', false));
                handleAxiosErrors(error);

                // Callbacks
                if (errorCallback) errorCallback();
                if (alwaysCallback) alwaysCallback();
            });
    };
};
export const showRemoveItemConfirmationModal = () => {
    return (dispatch, getState) => {
        const state = getState();
        const selected = getSelectedItems(
            state.inStoreProduct.list,
            state.inStoreProduct.selected
        );

        const modalName = 'confirm-remove-in-store-products-item-modal';
        let data = {
            heading: 'Proceed with removal?',
            noticeText: `Are you sure you want to remove ${pluralize(
                'item',
                selected.length,
                true
            )}?`,
            content: '',
        };

        // create modal
        createModal(modalName, data, function() {
            hideModal(modalName);
            dispatch(deleteSelectedInStoreProducts());
        });
    };
};
export const showRemoveCategoryConfirmationModal = () => {
    return (dispatch, getState) => {
        const state = getState();
        const { categoryList, removeCategoryForm } = state.inStoreProduct;
        const selectedCategory = getCategoryFromID(
            removeCategoryForm.selectedCategory,
            categoryList
        );

        const modalName = 'confirm-remove-in-store-products-category-modal';
        let data = {
            heading: 'Proceed with removal?',
            noticeText: `Are you sure you want to remove <u>${
                selectedCategory.Title
            }</u>?`,
            content: '',
        };

        // create modal
        createModal(modalName, data, function() {
            hideModal(modalName);
            dispatch(deleteSelectedInStoreCategory());
        });
    };
};
export const getAvailableSortBy = () => {
    return [
        // {
        //     text: 'Price ascending',
        //     icon: 'icon-sort-price-up',
        //     sortBy: 'Price',
        //     sortDirection: 'ASC',
        // },
        // {
        //     text: 'Price descending',
        //     icon: 'icon-sort-price-down',
        //     sortBy: 'Price',
        //     sortDirection: 'DESC',
        // },
        {
            localizedText: 'SORT.PRODUCT_NAME_ASC',
            icon: 'icon-sort-name-up',
            sortBy: 'Title',
            sortDirection: 'ASC',
        },
        {
            localizedText: 'SORT.PRODUCT_NAME_DESC',
            icon: 'icon-sort-name-down',
            sortBy: 'Title',
            sortDirection: 'DESC',
        },
        // {
        //     localizedText: 'SORT.PRODUCT_CODE_ASC',
        //     icon: 'icon-sort-number-up',
        //     sortBy: 'InternalItemID',
        //     sortDirection: 'ASC',
        // },
        // {
        //     localizedText: 'SORT.PRODUCT_CODE_DESC',
        //     icon: 'icon-sort-number-down',
        //     sortBy: 'InternalItemID',
        //     sortDirection: 'DESC',
        // },
    ];
};
